import { render, staticRenderFns } from "./forecastBottomTable.vue?vue&type=template&id=2f3794d6&scoped=true&"
import script from "./forecastBottomTable.vue?vue&type=script&lang=js&"
export * from "./forecastBottomTable.vue?vue&type=script&lang=js&"
import style0 from "./forecastBottomTable.vue?vue&type=style&index=0&id=2f3794d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3794d6",
  null
  
)

export default component.exports